import {
  IconButton
} from "@mui/material"
import {
  Dispatch,
  SetStateAction
} from "react"
import { useTheme } from "../providers/theme"
import {
  CloseRounded
} from '@mui/icons-material'
  
export function FilterPillShape({
  itemValue,
  filter,
  setFilterFunction
}: {
  itemValue: string,
  filter: string,
  setFilterFunction: Dispatch<SetStateAction<string>>
}) {
  const {mode} = useTheme()

  return (
    <div
      style={{
        borderRadius: "5em",
        width: "auto",
        display: "flex",
        gap: ".25em",
        fontSize: ".75em",
        alignItems: "center",
        paddingLeft: ".75em",
        paddingRight: ".25em",
        paddingBlock: ".25em",
        marginLeft: ".5em",
        marginBottom: ".5em",
        backgroundColor: mode === 'light' ? "#D6D6D6" : "#454545"
      }}
    >
      <p>
        {itemValue}
      </p>
      <IconButton
        onClick={() => {
          setFilterFunction(filter.split(';').filter(selectedItemsIterator => selectedItemsIterator !== itemValue).join(';'))
        }}
      >
        <CloseRounded sx={{ fontSize: ".5em" }} />
      </IconButton>
    </div>
  )
}